import {createUseStyles} from 'react-jss';
import {Theme} from '../themes/default';
import bgWoodDark from '../../assets/images/ncp/ncp_bg1.jpg';
import bgWoodLight from '../../assets/images/ncp/ncp_bg2.jpg';

const useMixTapanStyles = createUseStyles((theme: Theme) => {
    return {
        boxLeft: {
            backgroundImage: `url(${bgWoodDark})`,
            padding: theme.spacing(8),
            display: "flex",
            flexDirection:'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: "center",
            position: "relative",
        },
        boxRight: {
            backgroundImage: `url(${bgWoodLight})`,
            display: "flex",
            flexDirection:'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: "center",
        },
        wrapperRightText: {
            padding: theme.spacing(4),
        },
        textSecondary: {
            fontFamily: theme.fonts.poplar,
            fontSize: 'max(2.5vw,2.5vh)',
            color: theme.palette.secondary.main,
        },
        textPrimary: {
            fontFamily: theme.fonts.poplar,
            fontSize: 'max(2.5vw,2.5vh)',
            color: theme.palette.primary.main,
        },
        promotionInterval:{
            display: 'flex',
            justifyContent: "space-around",
            alignItems: 'center',
            alignContent: 'center',
            background: theme.palette.background.default,
            padding: theme.spacing(2),
            [theme.breakpoints.down('sm')]:{
                flexDirection: 'column'
            }
        },
        buttonRegulament: {
            fontFamily: theme.fonts.apex,
            fontSize: 'max(1vh,1vw)',
            fontWeight: 'bold',
            color: theme.palette.error.main,
            '&:hover':{
                textDecoration: 'underline',
            },
            [theme.breakpoints.down('sm')]: {
                fontSize: 'max(2vh,2vw)',
                position: 'absolute',
                bottom: '10px',
                left: '50%',
                transform: 'translate(-50%, 0)'
            }
        },
        dialog: {
            '& .MuiPaper-root': {
                backgroundColor: theme.palette.background.default,
                [theme.breakpoints.up('lg')]: {
                    minWidth: `${theme.breakpoints.values.md}${theme.breakpoints.unit}`
                }
            }
        },
        dialogTitle: {
            fontFamily: theme.fonts.poplar,
            fontSize: 'max(2vh,2vw)',
            color: theme.palette.primary.main,
            textAlign: 'center',
        },
        dialogContent: {},
        dialogContentList: {
            display: 'flex',
            flexWrap: 'wrap',
            '& img': {
                width: '50px',
                height: "auto",
            },
            '& .MuiListItemText-root span': {
                fontFamily: theme.fonts.apex,
                fontSize: 'max(1.5vh,1.5vw)',
                color: theme.palette.primary.main,
                paddingLeft: theme.spacing(2),
                fontWeight: 'bold'
            },
            '& .MuiListItem-root': {
                paddingTop: theme.spacing(2),
                width: '50%',
            }
        },
        buttonCloseModal: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.secondary.main,
            fontFamily: theme.fonts.apex,
            fontSize: 'max(1vh,1vw)',
            paddingLeft: theme.spacing(2),
            paddingRight:  theme.spacing(2),
            '&:hover':{
                color: theme.palette.primary.main,
            }
        },
         fullWidthImage: {
            width: '100%',
            height: 'auto',
            [theme.breakpoints.down('sm')]: {
                display: 'none'
            }
        },
        fullWidthImageMobile: {
            width: '100%',
            height: 'auto',
            display: 'none',
            [theme.breakpoints.down('sm')]: {
                display: 'block'
            }
        },
         bottomOverlay: {
            position: 'absolute',
            bottom: 'min(3vw,3vh)',
            left: '50%',
            transform: 'translateX(-50%)',
            display: 'flex', // vizibil pe desktop
            alignItems: 'center',
            gap: 'min(5vw,5vh)',
            //padding: theme.spacing(1, 2),
            borderRadius: '8px',
            [theme.breakpoints.down('sm')]: {
                display: 'flex', // vizibil și pe mobile
                position: 'absolute',
                bottom: 'min(40vw,40vh)',
                left: '50%',
                transform: 'translateX(-50%)',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: theme.spacing(1),
                marginTop: 0,
                gap: theme.spacing(1),
                borderRadius: '4px',
                width: '80%',
            }
        },
        bottomOverlayMobileOnly: {
            position: 'absolute',
            bottom: '20px',
            left: '50%',
            transform: 'translateX(-50%)',
            display: 'none', // ascuns pe desktop
            alignItems: 'center',
            gap: theme.spacing(12),
            padding: theme.spacing(1, 2),
            borderRadius: '8px',
            [theme.breakpoints.down('sm')]: {
                display: 'flex', // vizibil doar pe mobile
                position: 'absolute',
                bottom: 'min(40vw,40vh)',
                left: '50%',
                transform: 'translateX(-50%)',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: theme.spacing(1),
                marginTop: 0,
                gap: theme.spacing(1),
                borderRadius: '4px',
                width: '80%',
            }
        },
        bannerDesktop: {
            width: '100%',
            height: 'auto',
            cursor: 'pointer',
            display: 'block',
            [theme.breakpoints.down('sm')]: {
                display: 'none'
            }
        },
        // Stiluri pentru butonul mobile
        mobileButton: {
            position: 'absolute',
            display: 'none',
            [theme.breakpoints.down('sm')]: {
                display: 'block',
                fontSize: '0.6rem',
                padding: '(1vw 2vw)',
                bottom: 'min(27vw,27vh)',
                left: '55%',
                transform: 'translateX(-25%)',
                backgroundColor: '#88252c',
                color: '#ffffff',
                fontWeight: 'bold',
                borderRadius: '8px',
                boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                textTransform: 'uppercase',
                zIndex: 10,
            }
        },
        promoImage: {
            height: 'max(2vh, 2vw)',
            width: 'auto',
            display: 'block',
            margin: '0 auto',
            [theme.breakpoints.down('sm')]: {
                height: 'max(3vh, 3vw)',
                display: 'block',
            }
        },
        bottomText: {
            fontFamily: theme.fonts.apex,
            fontSize: 'max(1vh, 1vw)',
            color: theme.palette.primary.main,
            [theme.breakpoints.down('sm')]: {
                fontSize: 'max(1.5vh, 1.5vw)',
                textAlign: 'center',
                color: theme.palette.primary.main,
                fontWeight: 'bold'
            }
        },
      
    }
});

export default useMixTapanStyles;